@if (state === 'default') {
  <div
    class="Image-upload-sec d-flex align-items-start justify-content-start flex-column spacing-4 w-100">
    @if (label) {
      <span class="h4-bold primary-60">{{ label }}</span>
    }
    <label
      class="upload-img-sec pt-20"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      [class.over]="dropOver">
      <div class="custom-file drag-file d-flex flex-column">
        <h1 class="m-0 p-0">📷</h1>
        <div class="primary-80 h4-reg">
          <span class="h4-bold">Click here</span> to upload<br />
          {{ text }}
          <input
            #file
            class="w-100"
            type="file"
            id="file-input"
            [multiple]="isMultiple"
            (click)="onInputClick($event)"
            (change)="onFilesSelected($event)" />
        </div>
        <span class="h4-reg primary-60">{{ sizeLabel }}</span>
      </div>
    </label>
  </div>
}
<!-- *ngFor="let item of getValue('fileData')" -->
@if (state == 'uploaded') {
  <div
    class="upload-progress success d-flex flex-column spacing-8 alert alert-dismissible fade show">
    <div class="customer-name">
      <div class="media">
        <app-icon-container
          [Type]="'icon'"
          [Size]="'large'"
          [IconType]="'document'"
          [background_color]="'primary-20'"></app-icon-container>
        <div class="media-body">
          <div class="name d-flex align-items-center justify-content-between w-100">
            <h4 class="h3-bold m-0 d-flex align-items-center gap">
              {{ uploaded.fileName }}
            </h4>
          </div>
          <div class="contact d-flex align-items-start justify-content-between w-100">
            <div class="contact-info">
              <span class="h4-reg primary-60"
                >({{ uploaded.fileSize }}) {{ uploaded.fileType }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="close-btn" (click)="remove.emit(uploaded)">
      <app-ce-icon name="cancel" [svg_class]="['d-flex']"></app-ce-icon>
    </span>
  </div>
}
@if (state == 'showPreview') {
  <div class="d-flex flex-column spacing-4">
    @if (label) {
      <span class="h4-bold primary-60">{{ label }}</span>
    }
    <div class="upload-image">
      <img alt="uploaded image" height="149" width="149" ngSrc="/assets/user.jpg" />
      <div class="edit-icon">
        <app-action-btn
          [active]="false"
          [IconType]="'edit'"
          (custom_click)="editImg($event)"></app-action-btn>
      </div>
    </div>
  </div>
}
